// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"676":"cbe66689","1142":"35878071","1958":"cbe66689","2720":"cbe66689","7304":"b263dc62","7370":"cbe66689","8856":"cbe66689","9908":"cbe66689"}[chunkId] + ".chunk.css";
};